import { filing } from './toolkit';

/**
 * Firearms inventory (Form I-2, SCPA 2509), 1 page.
 * Rows are the estate's assets with category Firearm, ordered by id (the same order the
 * service uses for the continuation page it appends when there are more than 12).
 */
export default filing('file-1787254052736-708517b3-6c6a-462e-8217-d043df47ccf9.pdf', 'Firearms inventory', f => {
  f.shared('SURROGATES COURT OF THE STATE OF NEW YORK', 'estate.surrogateCourtCounty', "Surrogate's Court, County of");
  f.shared('Deceased', 'decedent.fullName', 'In the Matter of the Estate of (decedent name)');
  f.shared('FILE NUMBER', 'estate.courtFileNumber', 'File number');

  f.choice('certifiedBy', 'The undersigned certifies as', 'Certification', [
    { label: 'A fiduciary', value: 'Fiduciary', fields: ['Check Box1'] },
    { label: 'An attorney of record', value: 'Attorney', fields: ['Check Box2'] },
  ], 'checkbox');
  f.shared('Name of Fiduciary or Attorney', 'executor.fullName', 'Name of fiduciary or attorney');
  f.shared('Address if changed', 'executor.fullAddress', 'Address (if changed)');

  for (let i = 0; i < 12; i++) {
    const row = i + 1;
    const selector = `[${i}]`;
    f.shared(`Make${row}`, 'firearm.firearmMake', `Firearm ${row}: make`, { selector });
    f.shared(`Model${row}`, 'firearm.firearmModel', `Firearm ${row}: model`, { selector });
    f.shared(`Caliber or Gauge${row}`, 'firearm.firearmCaliber', `Firearm ${row}: caliber or gauge`, { selector });
    f.shared(`Serial ${row}`, 'firearm.firearmSerialNumber', `Firearm ${row}: serial number`, { selector });
    f.shared(`${row}`, 'firearm.marketValue', `Firearm ${row}: valuation`, { selector });
  }
  f.shared('TOTAL as indicated in section F2 of Inventory of Assets', 'totals.firearmInventoryTotal',
    'Total (as indicated in section F2 of Inventory of Assets)');
  // Ticked by probatedocs.service.ts when more than 12 firearms exist; it also appends the continuation page.
  f.shared('Check Box3', 'totals.firearmsContinuationAttached', 'More than 12 firearms (continuation attached)', {
    location: 'Computed: checked when the estate has more than 12 Firearm assets (the continuation page is appended by the service).',
  });

  // Attorney block.
  f.shared('Name', 'lawyer.fullName', 'Attorney: name');
  f.template('Address 1', '{{lawyer.addresses[0].addressLine1}} {{lawyer.addresses[0].addressLine2}}', 'Attorney: address (street)');
  f.template('Address 2', '{{lawyer.addresses[0].city}}, {{lawyer.addresses[0].state}} {{lawyer.addresses[0].zipCode}}', 'Attorney: address (city, state, zip)');
  f.shared('Telephone', 'lawyer.phone', 'Attorney: telephone');

  // Certification.
  f.signature('Certified to be true on 1', 'Certified to be true on (day and month): date signed (completed at signing)');
  f.signature('20', 'Certified to be true on, 20__ (year): date signed (completed at signing)');
  f.shared('Print Name', 'executor.fullName', 'Print name (under the signature)');
});
